import { useTranslation } from 'react-i18next'

import ForgetVisa from 'shared/icons/forget_visa.svg'

import styles from './styles.module.scss'

export const NeedVisaAlert = () => {
  const { t } = useTranslation()
  return (
    <div className={styles.visa}>
      <div className={styles.header}>
        <h6 className={styles.title}>{t('purchase_page.for_easy_flights')}</h6>
      </div>

      <div className={styles.visaBody}>
        <h6 className={styles.visaTitle}>
          <span>
            <img
              src={ForgetVisa}
              alt=""
              className={styles.forgetImage}
            />
          </span>

          {t('purchase_page.dont_forget_visa')}
        </h6>

        <p className={styles.visaDescription}>
          {t('purchase_page.visa_description')}
        </p>
      </div>
    </div>
  )
}
